import React, { useEffect, useState } from 'react';

const DownloadStatus = ({ status, message, onClose }) => {
  // Track visibility state to automatically hide the status after 5 seconds
  const [isVisible, setIsVisible] = useState(true);

  // Automatically hide the status after 5 seconds
  useEffect(() => {
    if (status && isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status, isVisible, onClose]);

  // Return null if component should be hidden
  if (!isVisible) {
    return null;
  }

  const statusColors = {
    'loading': 'bg-blue-600',
    'success': 'bg-green-600',
    'error': 'bg-red-600',
    'warning': 'bg-yellow-600'
  };

  const statusIcons = {
    'loading': '⏳',
    'success': '✅',
    'error': '❌',
    'warning': '⚠️'
  };

  return (
    <div className={`p-4 rounded-lg ${statusColors[status] || 'bg-gray-600'} text-white flex items-center justify-between mb-4`}>
      <div className="flex items-center">
        <span className="mr-2 text-xl">{statusIcons[status]}</span>
        <div>
          <h3 className="font-medium mb-1">{status.charAt(0).toUpperCase() + status.slice(1)}</h3>
          <p className="text-sm">{message}</p>
        </div>
      </div>
      {onClose && (
        <button 
          onClick={onClose}
          className="text-white hover:text-gray-300"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default DownloadStatus;
